import { render, staticRenderFns } from "./VFadeTransition.vue?vue&type=template&id=0811b9a0&scoped=true&"
import script from "./VFadeTransition.vue?vue&type=script&lang=js&"
export * from "./VFadeTransition.vue?vue&type=script&lang=js&"
import style0 from "./VFadeTransition.vue?vue&type=style&index=0&id=0811b9a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0811b9a0",
  null
  
)

export default component.exports